export default "__VITE_ASSET__sICrGvo7__"